import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import isNil from 'lodash/isNil';

import config from 'config';

import { IconWithDotBadge, AvailabilityIconWithDotBadge } from 'shared/components';
import { getUserInitials } from 'modules/user/utils/user';
import { AWAY, UNAVAILABLE, AVAILABLE } from 'modules/common/constants/userAvailabilityTypes';

import theme from './AppointmentParticipantsInfo.scss';


const isClalit = config.product_name === 'clalit';

const propTypes = {
  availability: PropTypes.oneOf([AWAY, UNAVAILABLE, AVAILABLE]),
  participantName: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  serviceName: PropTypes.string,
  avatar: PropTypes.string,
  assignedToGroup: PropTypes.bool,
  isMasked: PropTypes.bool,
  isPatientInWaitingRoom: PropTypes.bool,
  providerGroupSpecialty: PropTypes.object,
};

const defaultProps = {
  availability: null,
  participantName: null,
  firstName: null,
  lastName: null,
  serviceName: null,
  avatar: null,
  assignedToGroup: false,
  isMasked: false,
  isPatientInWaitingRoom: false,
  providerGroupSpecialty: null,
};

const ParticipantCard = ({ type, participantName, providerGroupSpecialty, assignedToGroup, avatar, firstName, lastName, serviceName, isMasked, availability, isPatientInWaitingRoom }) => {
  if (isClalit && type === 'CUSTOMER') return null;

  if (isMasked) {
    return (
      <div className={ classnames(theme.itemContainer, { [theme.clalitItemContainer]: isClalit }) }>
        <div className={ theme.iconContainer }>
          <div className={ theme.icon }>
            <IconWithDotBadge name="stethoscope" />
          </div>
        </div>

        <div className={ theme.titleContainer }>
          <div className={ classnames(theme.name, { [theme.clalitName]: isClalit }) }>*****</div>
        </div>
      </div>
    );
  }

  return (
    <div className={ classnames(theme.itemContainer, { [theme.clalitItemContainer]: isClalit }) }>
      <div className={ theme.iconContainer }>
        <div className={ theme.icon }>
          <Choose>
            <When condition={ isClalit }>
              <IconWithDotBadge name="stethoscope" />
            </When>
            <When condition={ assignedToGroup }>
              <IconWithDotBadge name="connected-dots" />
            </When>
            <When condition={ providerGroupSpecialty }>
              <IconWithDotBadge name="connected_dots_topv" />
            </When>
            <Otherwise>
              <AvailabilityIconWithDotBadge
                availability={ availability }
                userInfo={{ avatar, initials: getUserInitials({ firstName, lastName }) }}
              />
            </Otherwise>
          </Choose>
        </div>
      </div>

      <div className={ theme.titleContainer }>
        <div className={ classnames(theme.name, { [theme.clalitName]: isClalit }) }>
          <Choose>
            <When condition={ isClalit }>
              <FormattedMessage
                id="Appointments.PatientAppointmentCard.QueueType.Title"
                defaultMessage="** Queue Type"
              />
            </When>
            <When condition={ assignedToGroup }>
              <FormattedMessage
                id="General.ProvidersGroup"
                defaultMessage="** Providers group"
              />
            </When>
            <When condition={ providerGroupSpecialty }>
              <span>
                <span>{ providerGroupSpecialty.name }&nbsp;</span>
                <FormattedMessage
                  id="SpecialtyGroup.SelectionListView"
                  defaultMessage="** specialty group"
                />
              </span>
            </When>
            <Otherwise>
              { participantName }
            </Otherwise>
          </Choose>
        </div>
        <If condition={ !isNil(serviceName) }>
          <div className={ classnames(theme.additionalInfo, {
            [theme.clalitAdditionalInfo]: isClalit,
            [theme.blackMediumColor]: isClalit,
          }) }
          >
            { serviceName }
          </div>
        </If>
        <If condition={ isPatientInWaitingRoom }>
          <div className={ classnames(theme.additionalInfo, theme.inWaitingRoom, { [theme.clalitAdditionalInfo]: isClalit }) }>
            <FormattedMessage
              id="Appointment.List.UserAvailability.InWaitingRoom"
              defaultMessage="** In waiting room"
            />
          </div>
        </If>
      </div>
    </div>
  );
};

ParticipantCard.propTypes = propTypes;
ParticipantCard.defaultProps = defaultProps;

export default ParticipantCard;
